// @flow
import * as React from 'react';

import { Base } from '@gandi/ui';
import { mapTags, useTranslator } from '@gandi/translate';

import { InputTextField } from 'gandi.react-form';

import Row from './Row';

type Props = {| showHostingFields: boolean, topic?: string |};

function UserInfoFields({
  showHostingFields,
  topic,
}: Props): React.Element<typeof Base> {
  const { __ } = useTranslator();

  return (
    <Base backgroundColor="grey-lighter" padding="small" separatorBottom>
      <p>
        {mapTags(
          __('The fields with [[star:]] are mandatory'),
          () => ({
            star: <span style={{ color: 'red' }}>*</span>,
          }),
          {
            withHTML: true,
          }
        )}
      </p>

      <Row>
        <Base className="for-2-columns">
          <InputTextField
            name="firstname"
            label={__('First name')}
            required
            autoComplete="given-name"
          />
        </Base>
        <Base className="for-2-columns">
          <InputTextField
            name="lastname"
            label={__('Last name')}
            required
            autoComplete="family-name"
          />
        </Base>
      </Row>
      <Row>
        <Base className="for-2-columns">
          <InputTextField
            name="orgname"
            label={__('Company/Association')}
            required
            autoComplete="organization"
          />
        </Base>
        <Base className="for-2-columns">
          <InputTextField
            name="reply_to"
            label={__('Email address')}
            type="email"
            required
            autoComplete="email"
          />
        </Base>
      </Row>

      {showHostingFields && topic === 'breaching' && (
        <Row>
          <Base className="for-2-columns">
            <InputTextField
              type="tel"
              name="params.phone_number"
              label={__('Phone number')}
              required
              autoComplete="tel"
            />
          </Base>
        </Row>
      )}
    </Base>
  );
}

export default UserInfoFields;
